const DcFooter = () => {
  return (
    <footer className="text-lg-start bg-light text-muted mt-3">
      <div className="text-center bg-white pb-2">
        <img src="/대덕구청.gif" className="mb-3 ms-3 me-3" width="180px" />
        <img src="/대전광역시체육회.png" className="mb-3 ms-3 me-3" width="180px" />
        <img src="/디트_검은색.png" className="mb-3 ms-3 me-3" width="180px" />
        <img src="/k-water.png" className="mb-3 ms-3 me-3" width="130px" />
      </div>
      <section>
        <div className="text-start mt-2">
          <div className="row m-3">
            <div className="mb-md-0 mb-4">
              <br />
              <p className="text-center footer-bottom" style={{ fontSize: '0.8rem' }}>
                <span className="me-4">대전광역시 대덕구체육회</span>
                <span className="me-4">대전광역시 대덕구 동춘당로94번길 11</span>
                <span className="me-4">전화 : 042-934-8890</span>
                <span className="me-4">팩스 : 042-934-8878</span>
                <span className="me-4">사업자등록번호 : 511-82-67400</span>
                <span className="me-4">대표 : 박종길</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      <div
        className="text-center p-1"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', fontSize: '0.9rem' }}
      >
        <p>Copyright© 2021 CNK. All rights reserved.</p>
      </div>
    </footer>
  );
};
export default DcFooter;
